export const TRACKER = {
    CLOSE_MESSAGE: 'TRACKER_CLOSE_MESSAGE',
    EXECUTING: 'TRACKER_EXECUTING',
    ON_ORDER_FETCHED: 'TRACKER_ON_ORDER_FETCHED',
    ON_CONFIRMED: 'TRACKER_ON_CONFIRMED',
    ON_FAILED: 'TRACKER_ON_FAILED'
};
